import { useRef, useCallback } from "react";

export const useTilt = (maxTilt = 7) => {
    const ref = useRef(null);
    const frame = useRef(null);

    const onMouseMove = useCallback(
        (e) => {
            const el = ref.current;
            if (!el || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
            const rect = el.getBoundingClientRect();
            const px = (e.clientX - rect.left) / rect.width - 0.5;
            const py = (e.clientY - rect.top) / rect.height - 0.5;
            if (frame.current) cancelAnimationFrame(frame.current);
            frame.current = requestAnimationFrame(() => {
                el.style.transform = `rotateX(${(-py * maxTilt).toFixed(2)}deg) rotateY(${(px * maxTilt).toFixed(2)}deg) translateZ(0)`;
            });
        },
        [maxTilt],
    );

    const onMouseLeave = useCallback(() => {
        const el = ref.current;
        if (!el) return;
        if (frame.current) cancelAnimationFrame(frame.current);
        el.style.transform = "rotateX(0deg) rotateY(0deg)";
    }, []);

    return { ref, onMouseMove, onMouseLeave };
};
